module.exports = "p-progressBar {\r\n\theight: 6px;\r\n}\r\n\r\n.ui-progressbar {\r\n\tmargin: 4px 0px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/utility/loader/progress.component.css
// module id = ./src/app/components/utility/loader/progress.component.css
// module chunks = main